import { AppDispatch } from '../../../redux/store'
import { getGenerics, getGenericsConfiguration } from './api'
import {
  genericRequest,
  genericSuccess,
  genericFailure,
  configuration,
  genericConfigurationRequest,
  genericConfigurationFailure,
} from '../../../redux/genericSlice'
import { showCorrelationIdError } from '../../../redux/correlationIdSlice'

export const fetchGeneric = (pieceId: string, replace) => async (dispatch: AppDispatch) => {
  try {
    dispatch(genericRequest())
    const { data: salesData } = await getGenerics(pieceId)
    dispatch(genericSuccess(salesData))
  } catch (error: any) {
    if (error.showCorrelationId) {
      dispatch(showCorrelationIdError(error.CorrelationId))
    }
    if (error.response.status === 400) {
      replace()
    }
    dispatch(genericFailure(error.message))
  }
}

export const getConfiguration = () => async (dispatch: AppDispatch) => {
  try {
    dispatch(genericConfigurationRequest())
    const { data: configurationData } = await getGenericsConfiguration()
    dispatch(configuration(configurationData))
  } catch (error: any) {
    if (error.showCorrelationId) {
      dispatch(showCorrelationIdError(error.CorrelationId))
    }
    dispatch(genericFailure(error.message))
    dispatch(genericConfigurationFailure())
  }
}
